import React from "react";

function WhyChoose() {
  return (
    <section className="why-section">

      <h1>Why Choose KaalBet Cricket ID?</h1>

      <p className="subtitle">
        KaalBet Online offers trust, speed, and security for the best online gaming
        experience. From beginner to professional, it is easy to get started quickly.
      </p>

      <div className="cards">

        <div className="card">
          <h3>Reliable Platform</h3>
          <p>
            KaalBet Club is trusted by thousands of users, and is a transparent
            service with no hidden fees, secure and encrypted transactions for
            peace of mind, and quick payouts.
          </p>
        </div>

        <div className="card">
          <h3>One-Click ID Creation</h3>
          <p>
            You can get access to your Cricket ID within 5 minutes or less.
            You just have to give a quick WhatsApp message or phone call.
          </p>
        </div>

        <div className="card">
          <h3>24/7 Support</h3>
          <p>
            With us, you can game anytime and have effortless support.
            We guarantee you a pleasant and hassle-free experience
            at any hour of the day.
          </p>
        </div>

        <div className="card">
          <h3>Multiple Games</h3>
          <p>
            KaalBet Club offers many games, including football,
            tennis, horse racing, and even casino games like
            Teen Patti, Poker, etc.
          </p>
        </div>

        <div className="card">
          <h3>Secure Transactions</h3>
          <p>
            KaalBet Club guarantees instant deposits and withdrawals
            at popular platforms using UPI, Paytm, Google Pay, PhonePe,
            and net banking, all ranked for safety and security.
          </p>
        </div>

      </div>

    </section>
  );
}

export default WhyChoose;